import { render, staticRenderFns } from "./DPHV.vue?vue&type=template&id=6e76c19d&scoped=true"
import script from "./DPHV.vue?vue&type=script&lang=js"
export * from "./DPHV.vue?vue&type=script&lang=js"
import style0 from "./DPHV.vue?vue&type=style&index=0&id=6e76c19d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e76c19d",
  null
  
)

export default component.exports